export default __webpack_public_path__ + "static/media/cpr10.604f207c.jpg";